import axios from '@/libs/axios'

const facultadesService = {
  // Obtener todas las facultades
  getAll() {
    return axios.get('/facultades')
  },

  // Obtener una facultad por ID
  getById(id) {
    return axios.get(`/facultades/${id}`)
  },

  // Crear una nueva facultad
  create(data) {
    return axios.post('/facultades', data)
  },

  // Actualizar una facultad
  update(id, data) {
    return axios.put(`/facultades/${id}`, data)
  },

  // Eliminar una facultad (soft delete)
  delete(id) {
    return axios.delete(`/facultades/${id}`)
  }
}

export default facultadesService
